<div class="popup-container">
<button class="close-btn" (click)="onClose()" aria-label="Close"  [matTooltip]="'Close'" *ngIf="showCloseButton">
  <i class="bi bi-x"></i>
</button>
    <h2 class="title">Peer Group Selector</h2>
    <p class="info-note" *ngIf="search_type==='company'">
        <strong>Note:</strong> The selected company will be shown among the results regardless of selected filters.

    </p>

    <!-- <p class="info-note">
        <strong>Note:</strong> When a <em>focus company</em> is selected, it will always remain visible in the results,
        even if it does not match the applied filters (such as market cap). Filters are applied only to its <em>peer
            companies</em>. <br>
        In contrast, for a <em>thematic search</em> where no focus company is specified, the filters are applied across
        the <strong>entire result set</strong>.
    </p> -->



    <p class="subtitle">Company Type</p>
    <div class="company-section">
        <p class="error-note" *ngIf="showError">
            {{errorText}}
        </p>
        <mat-checkbox [(ngModel)]="isPublicCompany">
            Public Company
        </mat-checkbox>
        <div class="public-options" *ngIf="isPublicCompany">
            <mat-checkbox [(ngModel)]="useMinCap">Min Market Cap (USD)</mat-checkbox>

            <div *ngIf="isPublicCompany && useMinCap" class="input-wrapper">
                <input type="text" class="form-control" placeholder="e.g. 500M, 1.2B, 3T" [(ngModel)]="minCapInput"
                    name="minCapInput" required>
            </div>


            <mat-checkbox [(ngModel)]="useMaxCap">Max Market Cap (USD)</mat-checkbox>

            <div *ngIf="isPublicCompany && useMaxCap" class="input-wrapper">
                <input type="text" class="form-control" placeholder="e.g. 5B, 2T, 100M" [(ngModel)]="maxCapInput"
                    name="maxCapInput" required>
            </div>

            <p class="format-note" *ngIf="useMaxCap ||useMinCap ">
                * Please enter values in <strong>M</strong> (Million), <strong>B</strong> (Billion), or
                <strong>T</strong> (Trillion).<br>
                Examples: <code>500M</code>, <code>1.5B</code>, <code>3T</code>.
            </p>

        </div>

    </div>

    <div class="company-section">
        <mat-checkbox [(ngModel)]="isPrivateCompany">
            Private Company <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                [matTooltip]="'Our coverage includes ~130k private entities with the largest innovation output, assigned to a peer group based on patent similarity. Chinese private companies are not covered.'"
                matTooltipPosition="above">
            </i>
        </mat-checkbox>
    </div>

    <div class="button-wrapper">
        <button  mat-raised-button style="background-color: #7f7f7f;color: white;" (click)="resetToDefault()">Reset to Default</button>
        <button mat-raised-button color="primary" (click)="onConfirm()">Apply Selection</button>
    </div>
</div>